import { type OrderWSUpdate, WebSocketConnectionManager } from '../../index'
import type { ChanelActionType, IncomingMessagePayload, IWebSocketConnection, RepositoryWS } from '../wsClient'
import { PrivateConnectionChannels } from '../wsClient'
import type { OrderModel, OrderRepository } from '@trading/core'

export class OrderApiWs implements OrderRepository, RepositoryWS<OrderWSUpdate> {
  private wsChannel = PrivateConnectionChannels['ORDER']

  constructor(private wsManager: WebSocketConnectionManager) {
  }

  public get(): Promise<OrderModel[]> {
    throw new Error('Method not implemented.')
  }

  public getAll(): Promise<OrderModel[]> {
    throw new Error('Method not implemented.')
  }

  public create(): Promise<OrderModel> {
    throw new Error('Method not implemented.')
  }

  public delete(): Promise<void> {
    throw new Error('Method not implemented.')
  }

  public deleteBySymbol(_symbol: string): Promise<number> {
    throw new Error('Method not implemented.')
  }

  update(): Promise<OrderModel> {
    throw new Error('Method not implemented.')
  }

  async subscribeToChannelsAction(
    actionName: ChanelActionType,
    cb: (data: OrderWSUpdate) => void
  ): Promise<undefined | ReturnType<IWebSocketConnection['subscribeToChannelMessages']>> {
    const connection = await this.wsManager.getConnection('private')

    const unsubscribeChannel = connection.subscribeToChannelMessages(this.wsChannel)
    const unsubscribeHandler = connection.addChannelHandler(this.wsChannel, (data: IncomingMessagePayload<OrderWSUpdate>) => {
      if (data.type === actionName) {
        cb(data.data)
      }
    })

    this.unsubscribeChannel = unsubscribeChannel
    this.unsubscribeHandler = unsubscribeHandler

    return () => {
      unsubscribeHandler()
      unsubscribeChannel()
    }
  }

  public unsubscribeToChannel(): void {
    this.unsubscribeHandler()
    this.unsubscribeChannel()
  }

  private unsubscribeHandler: (() => void) = () => {
    throw new Error("Method not initialized.");
  }

  private unsubscribeChannel: (() => void) = () => {
    throw new Error("Method not initialized.");
  }
}
